import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Typography, HeaderVariants, Tags, } from "../../components/atoms/typography";
import { PlaceholderImage } from "../../components/atoms/placeholder-image";
import * as styles from "./styles.css";
export const FeatureStandAloneCategoryView = ({ standAloneData, }) => (React.createElement(React.Fragment, null, standAloneData.map((item, index) => {
    return (React.createElement("div", { className: styles.featuredCategoryStandalone, key: index },
        React.createElement("div", { className: styles.rowWrapperCategory },
            React.createElement("div", { className: styles.contentWrapper },
                React.createElement(RenderMaybe, null, M.map((title) => (React.createElement("div", { className: styles.title }, title)), item.titleM)),
                React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { classNameM: M.of(styles.desc), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
                    React.createElement(React.Fragment, null, description))), item.descriptionM))),
            React.createElement("div", { className: styles.imageWrapper },
                React.createElement("div", { className: styles.thumbnailImageContainer },
                    React.createElement("div", { className: styles.thumbnailImageWrapper },
                        React.createElement(PlaceholderImage, null),
                        React.createElement(SonicImage, { image: item.image, imageSizes: {
                                default: [100, "vw"],
                                maxWidthMediaQueries: [
                                    [699, "px", 320, "px"],
                                    [1023, "px", 440, "px"],
                                    [1439, "px", 600, "px"],
                                    [2559, "px", 800, "px"],
                                ],
                            }, extraImageWidths: [320, 480, 700], className: styles.thumbnailImage, fallbackImageSize: { width: 900 }, alt: "" })))))));
})));

